// @ts-nocheck
import styled from "styled-components";
import Icon from "../icons/icons";

// filter out bgColor so it doesn't leak into the DOM
const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "bgColor",
})`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: ${(props) => props.radius || "10px"};
  background-color: ${(props) => props.bgColor || "#333"};
`;

export default function IconWithBackground({
  icon,
  size = 12,
  color = "white",
  bgColor,
  radius,
  className = "",
  ...props
}) {
  return (
    <Container bgColor={bgColor} radius={radius} className={className} {...props}>
      <Icon icon={icon} size={size} color={color} />
    </Container>
  );
}
